import { useCallback } from 'react';
import useSendBiEvent from './useSendBiEvent';
import useBookDemoClickHandler from './useBookDemoClickHandler';
import usePaywall from '../components/dashboard/paywall/usePaywall';
import { PAGEBLOCK_EVENTS } from '../services/events';
import type { ActionPaywallSource } from '../components/dashboard/paywall/paywallTypes';
import { useLocation } from 'react-router';

const usePageblockEvents = () => {
  const { paywallState } = usePaywall();
  const onBookDemoClick = useBookDemoClickHandler();
  const sendBiEvent = useSendBiEvent();
  const { pathname } = useLocation();
  const mainPath = pathname.split('/')[1];

  const bookDemoAndSendEvent = useCallback(
    (source?: ActionPaywallSource) => {
      onBookDemoClick();
      sendBiEvent({
        name: PAGEBLOCK_EVENTS.bookDemoClick,
        props: {
          trialStatus: paywallState,
          source: source ?? mainPath,
        },
      });
    },
    [onBookDemoClick, sendBiEvent, paywallState, mainPath],
  );

  const sendOpenCtaDialogEvent = useCallback(
    (source?: ActionPaywallSource) => {
      sendBiEvent({
        name: PAGEBLOCK_EVENTS.openCtaDialogClick,
        props: {
          trialStatus: paywallState,
          source: source ?? mainPath,
        },
      });
    },
    [sendBiEvent, paywallState, mainPath],
  );

  const sendConnectSfClickEvent = useCallback(
    (source?: ActionPaywallSource) => {
      sendBiEvent({
        name: PAGEBLOCK_EVENTS.connectToSfClick,
        props: {
          trialStatus: paywallState,
          source: source ?? mainPath,
        },
      });
    },
    [sendBiEvent, paywallState, mainPath],
  );

  const sendScheduleMeetingEvent = useCallback(
    (source?: ActionPaywallSource) => {
      sendBiEvent({
        name: PAGEBLOCK_EVENTS.scheduleMeetingClick,
        props: {
          trialStatus: paywallState,
          source: source ?? mainPath,
        },
      });
    },
    [sendBiEvent, paywallState, mainPath],
  );

  const sendChatWithUsEvent = useCallback(
    (source?: ActionPaywallSource) => {
      sendBiEvent({
        name: PAGEBLOCK_EVENTS.chatWithUsClick,
        props: {
          trialStatus: paywallState,
          source: source ?? mainPath,
        },
      });
    },
    [sendBiEvent, paywallState, mainPath],
  );

  return {
    bookDemoAndSendEvent,
    sendOpenCtaDialogEvent,
    sendConnectSfClickEvent,
    sendChatWithUsEvent,
    sendScheduleMeetingEvent,
  };
};

export default usePageblockEvents;
